<template>
  <div class="bb-notifications-bar-main-mailing">
    <div class="bb-notifications-bar-main-mailing__subject">
      {{ subject }}
    </div>
    <div class="bb-notifications-bar-main-mailing__description">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsBarMainMailing',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    value () {
      const { comment } = this.item
      const value = comment.split('Æ')
      if (!value.length) return
      const [subject, description] = value
      return {
        subject,
        description
      }
    },
    subject () {
      const { subject } = this.value
      return subject
    },
    description () {
      const { description } = this.value
      return description
    }
  }
}
</script>

<style lang="scss" scoped>

  .bb-notifications-bar-main-mailing {
    display: grid;
    grid-gap: 7px 0;

    &__subject {
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
    }

    &__description {
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainMailing.vue